$(window).ready(function () {

    $('.carousel__play-button')
    .on('click', function(event){
        var video = $(this).find('video').get(0);

        $(this).removeClass('carousel__play-button');

        //
        video.controls = false;
        video.play()

    });

});
